<template>
  <section id="get-in-touch" class="container mt4">
    <div class="subhead">contact us</div>
    <h2 class="h2 serif fw700 mtq">Get in touch with us.</h2>
    <div class="container-main">
      <div class="cols-6">
        <p class="p fw700 mt2">Phone/Email</p>
        <p class="p mt1">
          <a href="tel:7192859523">719-285-9523</a><br>
          <a href="mailto:info@unitethebride.com">info@unitethebride.com</a>
        </p>
      </div>
      <div class="cols-6">
        <p class="p fw700 mt2">Mailing Address</p>
        <p class="p mt1">
          Unite the Bride<br>
          6547 N Academy Blvd #535<br>
          Colorado Springs, CO 80918
        </p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {

    }
  }
}
</script>

<style lang="scss">

</style>


// WEBPACK FOOTER //
// src/components/GetInTouch.vue